import React from 'react';
import rangeInclusive from 'range-inclusive';

type Callback = (page: number) => void;

interface LoadMoreProps {
  currentPage: number;
  pages: number;
  callback: Callback;
  fragment: string;
  digits: number
}

function LoadMore({currentPage, pages, callback, fragment, digits}: LoadMoreProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const page = Number(e.currentTarget.dataset.page || '1');
    callback(page);
  };

  if (pages === 0) {
    return <div />;
  }

  if (pages === 1) {
    return (
      <React.Fragment>
        <a href={`${fragment}?page=1`} onClick={handleClick} data-page={1}>1</a>
      </React.Fragment>
    );
  }

  let pageRange = rangeInclusive(Math.max(1, currentPage - 2), Math.min(currentPage + 2, pages));

  if (currentPage > digits + 2) {
    pageRange = [1, -1, ...pageRange];
  } else if (currentPage > digits + 1) {
    pageRange =[1, ...pageRange];
  }

  if (pages - currentPage > digits + 1) {
    pageRange = [...pageRange, -2, pages];
  } else if (pages - currentPage > digits) {
    pageRange = [...pageRange, pages];
  }

  const pageLinks = pageRange.map((page: number) => {
    if (page < 0) {
      return <span key={page}>...</span>;
    } else {
      return <a className={page === currentPage ? 'active' : ''} href={`${fragment}?page=${page}`} onClick={handleClick} key={page} data-page={page}>{page}</a>;
    }
  });

  return (
    <React.Fragment>
      {pageLinks}
    </React.Fragment>
  );
}

export default LoadMore;
